import { useEffect, useState } from 'react';
import {
  Button,
  InputAdornment,
  TextField,
  TextFieldProps,
  Typography,
} from '@mui/material';

export type PhoneInputWithOTPProps = TextFieldProps & {
  onChange?: () => void;
  value?: string;
  name?: string;
  onRequestOtp?: (phoneNumber: string) => void;
};

export const PhoneInputWithOTP: React.FC<PhoneInputWithOTPProps> = (props) => {
  const { onChange, onRequestOtp, value, name, ...restProps } = props;

  // ======================= STATE
  const [countdown, setCountdown] = useState(0);

  // ======================= EVENTS
  useEffect(() => {
    let timer: NodeJS.Timeout;

    if (countdown > 0) {
      timer = setTimeout(() => {
        setCountdown((prevCountdown) => prevCountdown - 1);
      }, 1000);
    }

    return () => {
      clearTimeout(timer);
    };
  }, [countdown]);

  const handleAction = () => {
    setCountdown(60);
    if (onRequestOtp && typeof onRequestOtp === 'function' && value) {
      onRequestOtp(value);
    }
  };

  // ======================= VIEWS
  return (
    <TextField
      name={name}
      value={value}
      onChange={onChange}
      sx={{
        '& .MuiOutlinedInput-root': {
          paddingRight: 0,
        },
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Typography
              fontSize={'0.875rem'}
              color="secondary"
              fontWeight={500}
            >
              +60
            </Typography>
          </InputAdornment>
        ),
        endAdornment: onRequestOtp && (
          <Button
            sx={{
              height: '100%',
              minWidth: '30%',
              borderEndStartRadius: 0,
              borderStartStartRadius: 0,
              whiteSpace: 'nowrap',
              lineHeight: 2,
            }}
            onClick={handleAction}
            variant="contained"
            disabled={countdown !== 0}
          >
            {countdown ? `${countdown}S` : 'Request OTP'}
          </Button>
        ),
      }}
      {...restProps}
    />
  );
};

// ======================= EXPORT
export default PhoneInputWithOTP;
